module.exports = __webpack_public_path__ + "img/26_95.30d3080a.png";